var _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var SvgLogoDark = function SvgLogoDark(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 25,
    viewBox: "0 0 157 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13.092.5 13.425 7.714v7.715L13.091 8.214V.5Z",
    fill: "url(#paint0_linear_264_13644)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m13.092 24.5 13.425-7.636V9.227l-13.425 7.637V24.5Z",
    fill: "url(#paint1_linear_264_13644)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.092.5 0 8.214v7.715l13.092-7.715V.5Z",
    fill: "url(#paint2_linear_264_13644)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.092 24.5 0 16.864V9.227l13.092 7.637V24.5Z",
    fill: "url(#paint3_linear_264_13644)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.653 20.006h2.253V4.804h-2.253v15.202Zm4.641-6.977V11.2l4.05-6.395h2.48l-4.664 7.213v.043l4.96 7.946H51.57l-4.277-6.977Zm21.864-8.225-3.14 11.154c-.227.84-.34 1.615-.34 1.615h-.046s-.09-.797-.296-1.615L62.493 4.804h-2.321l4.095 15.202h2.616l2.776-9.862c.273-.969.478-2.153.478-2.153h.045s.205 1.184.478 2.153l2.775 9.862h2.617L80.26 4.804h-2.32l-2.958 11.154c-.227.818-.295 1.615-.295 1.615h-.046s-.114-.775-.341-1.615L71.16 4.804h-2.002ZM97.67 20.006h-9.714V4.804h9.327v1.852h-7.075v4.758h5.756v1.852h-5.756v4.888h7.462v1.852Zm8.104 0h2.253v-9.862c0-.861-.159-2.218-.159-2.218h.045s.751 1.378 1.342 2.218l7.167 9.862h2.206V4.804h-2.252v9.883c0 .84.159 2.197.159 2.197h-.045s-.751-1.378-1.342-2.197l-7.144-9.883h-2.23v15.202Zm27.684 0h-2.253V6.656H125.7V4.804h13.263v1.852h-5.505v13.35Zm21.176 0h2.343l-5.779-15.202h-2.366l-5.778 15.202h2.32l1.569-4.306.615-1.83 1.798-4.824c.273-.775.637-2.154.637-2.154h.045s.341 1.379.614 2.154l1.775 4.823h.001l.611 1.82 1.595 4.317Z",
    fill: "#000"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_264_13644",
    x1: 37.963,
    y1: 8.171,
    x2: 4.861,
    y2: 8.171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#996939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0A875"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_264_13644",
    x1: 19.805,
    y1: 24.5,
    x2: 22.729,
    y2: -4.747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272728"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B4B4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_264_13644",
    x1: 13.173,
    y1: 3.663,
    x2: 0.554,
    y2: 14.109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#996939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0A875"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_264_13644",
    x1: 6.546,
    y1: 24.5,
    x2: 6.546,
    y2: 9.227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#363636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333232"
  })))));
};
export default SvgLogoDark;